interface CheckboxFieldProps {
    name: string;
    label: string;
    value: boolean;
    onChange: (name: string, value: boolean) => void;
    disabled?: boolean | null;
}

export const CheckboxField = ({
    name,
    label,
    value,
    onChange,
    disabled,
}: CheckboxFieldProps) => {
    return (
        <div className='mb-2 checked-custom'>
            <input
                type='checkbox'
                className='form-check-input  '
                checked={value}
                name={name}
                id={name + '_' + value}
                disabled={disabled ?? false}
                onChange={(event) => onChange(name, event.target.checked)}
            />
            <label
                htmlFor={name + '_' + value}
                className='form-check-label'
                style={{ marginLeft: 5 }}
            >
                {label}
            </label>
        </div>
    );
};
